/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResUser
 */
export interface MainDataResUser {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResUser
     */
    version: MainDataVersion;
    /**
     * 
     * @type {User}
     * @memberof MainDataResUser
     */
    data?: User;
    /**
     * 
     * @type {string}
     * @memberof MainDataResUser
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResUser
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResUser
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResUser
     */
    limit?: number | null;
}

export function MainDataResUserFromJSON(json: any): MainDataResUser {
    return MainDataResUserFromJSONTyped(json, false);
}

export function MainDataResUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : UserFromJSON(json['data']),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResUserToJSON(value?: MainDataResUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': UserToJSON(value.data),
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


